<div class="space-y-3">
    <div class="flex items-center justify-between">
        <div>
            <h3 class="text-sm font-bold text-neutral-800">Atributos de variación</h3>
            <p class="text-xs text-neutral-500">
                Ej.: Talla (S, M, L) o Color (Rojo, Azul). Los productos de este tipo podrán generar variaciones combinándolos.
            </p>
        </div>
        <button type="button" (click)="addAttribute()" [disabled]="loading()"
            class="cursor-pointer px-3 py-1.5 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 disabled:opacity-50">
            + Atributo
        </button>
    </div>

    @if(loading() && !attributes.length){
    <p class="text-sm text-neutral-500">Cargando...</p>
    }

    @for(attribute of attributes; track $index; let i = $index){
    <div class="p-3 border border-neutral-200 rounded-xl space-y-2" [class.border-yellow-400]="attribute.dirty">
        <div class="flex items-center gap-2">
            <input type="text" [(ngModel)]="attribute.name" (ngModelChange)="attribute.dirty = true"
                placeholder="Nombre del atributo (ej. Talla)"
                class="flex-1 px-3 py-2 text-sm border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
            <button type="button" (click)="saveAttribute(attribute)" [disabled]="loading() || !attribute.dirty"
                class="cursor-pointer px-3 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:opacity-40">
                Guardar
            </button>
            <button type="button" (click)="deleteAttribute(attribute, i)" [disabled]="loading()"
                class="cursor-pointer px-3 py-2 text-sm font-medium text-red-600 border border-red-200 rounded-lg hover:bg-red-50 disabled:opacity-40">
                Eliminar
            </button>
        </div>

        <div class="flex flex-wrap gap-1.5">
            @for(term of attribute.terms; track $index; let t = $index){
            <span class="inline-flex items-center gap-1 px-2 py-1 text-xs bg-purple-50 text-purple-800 border border-purple-200 rounded-full">
                <input type="text" [(ngModel)]="term.value" (ngModelChange)="attribute.dirty = true"
                    [style.width.ch]="(term.value.length || 1) + 1"
                    class="bg-transparent focus:outline-none">
                <button type="button" (click)="removeTerm(attribute, t)" class="cursor-pointer text-purple-500 hover:text-red-600"
                    aria-label="Quitar término">&times;</button>
            </span>
            }
        </div>

        <div class="flex items-center gap-2">
            <input type="text" [(ngModel)]="attribute.newTerm" (keydown.enter)="$event.preventDefault(); addTerm(attribute)"
                placeholder="Añadir valores (separados por comas) y pulsa Enter"
                class="flex-1 px-3 py-1.5 text-sm border border-neutral-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
            <button type="button" (click)="addTerm(attribute)"
                class="cursor-pointer px-3 py-1.5 text-sm text-neutral-700 border border-neutral-300 rounded-lg hover:bg-neutral-50">
                Añadir
            </button>
        </div>
    </div>
    } @empty {
    @if(!loading()){
    <p class="text-sm text-neutral-500">Este tipo aún no tiene atributos.</p>
    }
    }
</div>
